import React, { createRef } from "react";
import { connect } from "react-redux";
import Button from "../../components/button";

import userPic from "../../assets/images/default-picture.png";
import moment from "moment-timezone";
import _ from "lodash";
import Scroll from "react-scroll";

// import DingBell from "../../assets/audios/note_sms.mp3";

import Link from "../../components/anchor";
import { ButtonDropdown } from "reactstrap";

import { CircularProgress } from "@material-ui/core";
import { uploadChatFile, clearChatData } from "../../apiRoutes";
import Model from "../../components/modal";
import MakeAPICall from "../../apiCalls/common";

import socket from "../../utils/socket";

import EmojiInput from "../../components/emojiInput";
import EmojiTextInput from "../../components/emojiTextInput";

const Element = Scroll.Element;
const scroller = Scroll.scroller;

class Chat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatId: null,
      doctorData: null,
      chatMessage: null,
      chatMessageList: [],
      userData: props.auth && props.auth.user ? props.auth.user : {},
      uploadingChatFile: false,
      chatFileLargeModel: false,
      apiCallParams: null,
      typingDoctorFlg: false,
      doneTypingInterval: 900,
      typingAdminFlg: false,
      typingAdminFlgStart: false,
      adminTypingData: null,
      msgInputValue: ""
    };
    this.inputUserChatFiles = createRef();
  }

  componentDidMount() {
    // Handle if chat disconneted from backed

    // TODO - use this insted of api calls
    // socket.on("connect", function () {
    //   console.log("Admin Socket Connected");
    //   socket.emit('join', "ADMINS");
    // });

    // socket.on("disconnect", reason => {
    //   console.log("Socket Disconnect");
    // });

    // socket.on("IC_SUPPORT", (data) => {
    //   console.log("Message only for support users: ", data);
    // });

    socket.on("adminMessageDone", this.insertAdminChatMsg);

    socket.on("doctorMessageDone", this.insertDoctorChatMsg);

    socket.on("doctorReadAllMsg", this.readDoctorChatMsg);

    socket.on("doctorTypingStart", this.handleDoctorTyping);

    socket.on("adminTypingStart", this.handleAdminTyping);
  }

  componentWillReceiveProps(newProps) {
    this.updateData(newProps);
    this.setState({
      typingDoctorFlg: false,
      typingAdminFlg: false
    });
  }

  // componentDidUpdate() {
  //   this.scrollToLastMsg();
  // }

  // Doctor Typing Hanble below code

  typingTimer = null;

  handleDoctorTyping = data => {
    if (this.state.chatId === data.chatId) {
      this.setState({
        typingDoctorFlg: true
      });
      // scroller.scrollTo('last-msg', {
      //   duration: 200,
      //   delay: 30,
      //   smooth: true,
      //   containerId: 'messageContainer',
      //   offset: 300, // Scrolls to element + 100 pixels down the page
      // });
      if (this.state.typingAdminFlgStart === false) {
        this.scrollToLastMsg();
        this.setState({
          typingAdminFlgStart: true
        });
      }
    }
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(
      this.doneTyping,
      this.state.doneTypingInterval
    );
  };

  //doctor is "finished typing," do something
  doneTyping = () => {
    this.setState({
      typingDoctorFlg: false,
      typingAdminFlgStart: true
    });
  };

  // admin typing
  typingTimerAdmin = null;

  handleAdminTyping = data => {
    if (
      this.state.chatId === data.chatId &&
      this.state.userData._id !== data._id
    ) {
      this.setState({
        typingAdminFlg: true,
        adminTypingData: data
      });
      // scroller.scrollTo('last-msg', {
      //   duration: 200,
      //   delay: 30,
      //   smooth: true,
      //   containerId: 'messageContainer',
      //   offset: 300, // Scrolls to element + 100 pixels down the page
      // });
      // this.scrollToLastMsg();
    } else {
      this.setState({
        typingAdminFlg: false
      });
    }
    clearTimeout(this.typingTimerAdmin);
    this.typingTimerAdmin = setTimeout(
      this.doneTypingAdmin,
      this.state.doneTypingInterval
    );
  };

  //admin is "finished typing," do something
  doneTypingAdmin = () => {
    this.setState({
      typingAdminFlg: false
    });
  };

  readDoctorChatMsg = data => {
    if (data.status && data.chatId === this.state.chatId) {
      let copyData = JSON.parse(JSON.stringify(this.state.chatMessageList));
      copyData = _.map(copyData, e => {
        if (e.fromAdmin) {
          e.readStatus = true;
        }
        return e;
      });
      this.setState({
        chatMessageList: copyData
      });
    }
  };

  insertAdminChatMsg = data => {
    if (data.status) {
      let msgData = data.data.data;
      if (this.state.chatId === data.data.chatId) {
        this.setState(prevState => ({
          chatMessageList: [...prevState.chatMessageList, msgData]
        }));

        socket.emit("adminReadChat", {
          chatId: this.state.chatId
        });
        if (this.state.chatMessageList.length === 1)
          this.props.updateNewDocChat();
        setTimeout(() => {
          // scroller.scrollTo('last-msg', {
          //   duration: 200,
          //   delay: 30,
          //   smooth: true,
          //   containerId: 'messageContainer',
          //   offset: 300, // Scrolls to element + 100 pixels down the page
          // });
          this.scrollToLastMsg();
        }, 50);
      }
    }
  };

  insertDoctorChatMsg = data => {
    if (data.status) {
      let msgData = data.data;
      if (this.state.chatId === msgData.chatId) {
        this.setState(prevState => ({
          chatMessageList: [...prevState.chatMessageList, msgData]
        }));
        // setTimeout(() => {
        //   // scroller.scrollTo('last-msg', {
        //   //   duration: 200,
        //   //   delay: 30,
        //   //   smooth: true,
        //   //   containerId: 'messageContainer',
        //   //   offset: 300, // Scrolls to element + 100 pixels down the page
        //   // });
        //   this.scrollToLastMsg();
        // }, 300);
      }
    } else {
      console.log("Something went wrong, Please try again!", data);
    }
  };

  handleSendMsg = event => {
    event.preventDefault();
    event.stopPropagation();
    if (this.state.msgInputValue.trim() !== "") {
      let obj = {
        adminId: this.state.userData._id,
        message: this.state.msgInputValue.trim(),
        author:
          this.state.userData.firstName + " " + this.state.userData.lastName,
        userType: this.state.userData.userType,
        chatId: this.state.chatId,
        imageUrl: this.state.userData.profilePic.original
      };
      socket.emit("sendAdminMessage", obj);

      this.setState({
        msgInputValue: ""
      });
    }
  };

  scrollToLastMsg = () => {
    //let elmnt = document.getElementById("last-msg");
    //if (elmnt) elmnt.scrollIntoView();
    scroller.scrollTo("last-msg", {
      duration: 20,
      // delay: 30,
      // smooth: true,
      containerId: "messageContainer",
      offset: 300 // Scrolls to element + 100 pixels down the page
    });
  };


  updateData(props) {
    if (props.currentDoctorChat) {
      this.setState({
        doctorData: props.currentDoctorChat.doctorId
      });
    }
    if (props.chatMessage) {
      this.setState({
        chatMessage: props.chatMessage,
        chatMessageList: props.chatMessage.data,
        chatId: props.chatMessage.chatId
      });
      setTimeout(() => {
        // scroller.scrollTo('last-msg', {
        //   duration: 400,
        //   delay: 80,
        //   smooth: true,
        //   containerId: 'messageContainer',
        //   offset: 300, // Scrolls to element + 100 pixels down the page
        // });
        this.scrollToLastMsg();
      }, 50);
    }
  }

  // For chat file upload
  handleFileInput = () => {
    this.inputUserChatFiles.current.click();
  };

  onChangeHandler = event => {
    this.setState({
      uploadingChatFile: true
    });

    // scroller.scrollTo('last-msg', {
    //   duration: 200,
    //   delay: 30,
    //   smooth: true,
    //   containerId: 'messageContainer',
    //   offset: 300, // Scrolls to element + 100 pixels down the page
    // });
    this.scrollToLastMsg();

    let maxAllowedSize = 5 * 1024 * 1024,
      fileSizebig = false,
      bodyData = new FormData(),
      files = event.target.files;
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (files[i].size > maxAllowedSize) {
          fileSizebig = true;
          break;
        } else {
          fileSizebig = false;
          let currentTime = new Date().toLocaleString();
          // files[i].name = currentTime + "_" + files[i].name;
          let attachingFile = new File(
            [event.target.files[i]],
            `${currentTime}_${event.target.files[i].name}`,
            { type: event.target.files[i].type }
          );
          bodyData.append("attachments[]", files[i]);
        }
      }
      if (fileSizebig) {
        this.setState({
          uploadingChatFile: false,
          chatFileLargeModel: true
        });
      } else {
        let apiCallObj = {
          reqType: "POST",
          reqUrl: uploadChatFile,
          dataObj: bodyData,
          successCallback: async res => {
            if (res.data.data.length) {
              res.data.data.map((uploadFileUrl, index) => {
                let obj = {
                  adminId: this.state.userData._id,
                  message: "",
                  author: this.state.userData
                    ? this.state.userData.firstName
                    : this.state.userData.firstName,
                  userType: this.state.userData.userType.includes(
                    "SUPPORT_STAFF"
                  )
                    ? "SUPPORT_STAFF"
                    : "ADMIN",
                  attachmentUrl: uploadFileUrl || "",
                  attachmentName: uploadFileUrl.split("/").pop() || "",
                  chatId: this.state.chatId,
                  imageUrl:
                    this.state.userData.profilePic &&
                      this.state.userData.profilePic.original
                      ? this.state.userData.profilePic.original
                      : null
                };
                // socket.emit('sendMessage', obj);
                socket.emit("sendAdminMessage", obj);
                this.setState({
                  uploadingChatFile: false
                });
              });
              this.setState({
                uploadingChatFile: false
              });
            }
          },
          failureCallback: err => {
            console.log("Something went wrong, Please try again ! ", err);
            this.setState({
              uploadingChatFile: false
            });
          }
        };

        this.setState({
          apiCallParams: apiCallObj
        });
      }
    }
  };

  // Admin typing event
  handleKeyDown = event => {
    let obj = {
      chatId: this.state.chatId,
      _id: this.state.userData._id || null,
      firstName: this.state.userData.firstName || null,
      userType: this.state.userData.userType || null
    };
    socket.emit("supportStaffTyping", obj);
    if (
      event.keyCode === 13 &&
      !event.shiftKey &&
      this.state.msgInputValue.trim() !== ""
    )
      this.handleSendMsg(event);
  };

  clearChat = () => {
    let bodyData = new FormData();
    bodyData.append("chatId", this.state.chatId);

    let apiCallObj = {
      reqType: "POST",
      reqUrl: clearChatData,
      dataObj: bodyData,
      successCallback: async res => {
        let data = {
          doctorId: {
            _id: this.state.userData._id
          }
        };
        this.props.updateChatList();
        this.setState({
          uploadingChatFile: false
        });
        this.scrollToLastMsg();
      },
      failureCallback: err => {
        console.log("Something went wrong, Please try again ! ", err);
        this.setState({
          uploadingChatFile: false
        });
      }
    };

    this.setState({
      apiCallParams: apiCallObj
    });
  };

  handleMsgInputChange = event => {
    this.setState({
      msgInputValue: event.target.value
    });
  };

  handleEmojiInput = emoji => {
    this.setState({
      msgInputValue: (this.state.msgInputValue + " " + emoji).trim()
    });
  };

  render() {
    return (
      <div className="chat-window-container">
        <div className="d-flex flex-row align-items-center justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <img
              className="rounded-circle prac-pic"
              src={
                this.state.doctorData && this.state.doctorData.profilePic
                  ? this.state.doctorData.profilePic.original
                  : userPic
              }
              alt="pic"
            />
            <p className="mb-0">
              {" "}
              {this.state.doctorData
                ? this.state.doctorData.firstName +
                " " +
                this.state.doctorData.lastName +
                " (Doctor)"
                : ""}
            </p>
          </div>
          {this.state.userData.userType !== "SUPPORT_STAFF" && (
            <Button
              className="btn-auto-width"
              title="Clear Chat"
              type="button"
              clickEvent={this.clearChat}
            />
          )}
        </div>
        <div className="messages-container" id="messageContainer">
          {this.state.chatMessageList.map((value, index) => {
            if (value.fromAdmin) {
              return (
                <div
                  id={
                    this.state.chatMessageList.length - 1 === index
                      ? "last-msg"
                      : "chat-" + index
                  }
                  className="from-support-msg-cont"
                  key={index}
                >
                  <p className="mb-0 bold name">
                    {value.author} (
                    {value.userType === "SUPPORT_STAFF" ? "Support" : "Admin"})
                  </p>
                  <div className="message">
                    {/* {value.message} */}
                    {value.message === "" && value.attachmentUrl ? (
                      value.attachmentUrl
                        .split(".")
                        .pop()
                        .match(/jpg|jpef|png|gif/gi) ? (
                        <a href={value.attachmentUrl} target="_blank">
                          <img
                            src={value.attachmentUrl}
                            className="img-thumbnail chat-attachment-img"
                          />
                        </a>
                      ) : (
                        <div className="chat-document-attached m-1 ml-0">
                          <ButtonDropdown direction="down" className="w-100">
                            <Link
                              title={
                                value.attachmentUrl
                                  .split(".")
                                  .pop()
                                  .toLowerCase() === "pdf"
                                  ? "PDF"
                                  : "Other"
                              }
                              href={value.attachmentUrl}
                              target="_blank"
                              className={
                                value.attachmentUrl
                                  .split(".")
                                  .pop()
                                  .toLowerCase() === "pdf"
                                  ? "consult-note-pdf-btn font-12 text-decoration-none"
                                  : "consult-note-pdf-btn font-12 Other-doc text-decoration-none"
                              }
                            />
                            <Button
                              id="caret"
                              title={"Document "}
                              className="gray small pl-2 pr-0 m-0 text-left consult-note-btn font-12"
                              clickEvent={() => {
                                window.open(value.attachmentUrl, "_blank");
                              }}
                            />
                          </ButtonDropdown>
                        </div>
                      )
                    ) : (
                      // value.message
                      <span
                        className="text-break"
                        dangerouslySetInnerHTML={{
                          __html: value.message.replace(
                            /(?:\r\n|\r|\n)/g,
                            "<br />"
                          )
                        }}
                      ></span>
                    )}
                  </div>
                  <p className="message-date d-flex flex-row align-items-center">
                    {moment(value.createdAt)
                      .tz("Australia/Brisbane")
                      .format("LLL")}{" "}
                    &nbsp;
                    {value.readStatus ? (
                      <svg
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 15"
                        width="16"
                        height="15"
                      >
                        <path
                          fill="#4FC3F7"
                          d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
                        ></path>
                      </svg>
                    ) : (
                      <svg
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 15"
                        width="16"
                        height="15"
                      >
                        <path
                          fill="#263238"
                          fillOpacity=".4"
                          d="M17.394 5.035l-.57-.444a.434.434 0 0 0-.609.076l-6.39 8.198a.38.38 0 0 1-.577.039l-.427-.388a.381.381 0 0 0-.578.038l-.451.576a.497.497 0 0 0 .043.645l1.575 1.51a.38.38 0 0 0 .577-.039l7.483-9.602a.436.436 0 0 0-.076-.609zm-4.892 0l-.57-.444a.434.434 0 0 0-.609.076l-6.39 8.198a.38.38 0 0 1-.577.039l-2.614-2.556a.435.435 0 0 0-.614.007l-.505.516a.435.435 0 0 0 .007.614l3.887 3.8a.38.38 0 0 0 .577-.039l7.483-9.602a.435.435 0 0 0-.075-.609z"
                        ></path>
                      </svg>
                    )}
                  </p>
                </div>
              );
            } else {
              return (
                <div
                  id={
                    this.state.chatMessageList.length - 1 === index
                      ? "last-msg"
                      : "chat-" + index
                  }
                  className="from-user-msg-cont"
                  key={index}
                >
                  <p className="mb-0 bold name">
                    {" "}
                    {this.state.doctorData
                      ? this.state.doctorData.firstName +
                      " " +
                      this.state.doctorData.lastName +
                      " (Doctor)"
                      : ""}
                  </p>
                  <div className="message">
                    {/* {value.message} */}
                    {value.message === "" && value.attachmentUrl ? (
                      value.attachmentUrl
                        .split(".")
                        .pop()
                        .match(/jpg|jpef|png|gif/gi) ? (
                        <a href={value.attachmentUrl} target="_blank">
                          <img
                            src={value.attachmentUrl}
                            className="img-thumbnail chat-attachment-img"
                          />
                        </a>
                      ) : (
                        <div className="chat-document-attached m-1 ml-0">
                          <ButtonDropdown direction="down" className="w-100">
                            <Link
                              title={
                                value.attachmentUrl
                                  .split(".")
                                  .pop()
                                  .toLowerCase() === "pdf"
                                  ? "PDF"
                                  : "Other"
                              }
                              href={value.attachmentUrl}
                              target="_blank"
                              className={
                                value.attachmentUrl
                                  .split(".")
                                  .pop()
                                  .toLowerCase() === "pdf"
                                  ? "consult-note-pdf-btn font-12"
                                  : "consult-note-pdf-btn font-12 Other-doc"
                              }
                            />
                            <Button
                              id="caret"
                              title={"Document "}
                              className="gray small pl-2 pr-0 m-0 text-left consult-note-btn font-12"
                              clickEvent={() => {
                                window.open(value.attachmentUrl, "_blank");
                              }}
                            />
                          </ButtonDropdown>
                        </div>
                      )
                    ) : (
                      // value.message
                      <span
                        className="text-break"
                        dangerouslySetInnerHTML={{
                          __html: value.message.replace(
                            /(?:\r\n|\r|\n)/g,
                            "<br />"
                          )
                        }}
                      ></span>
                    )}
                  </div>
                  <p className="message-date d-flex flex-row align-items-center">
                    {moment(value.createdAt)
                      .tz("Australia/Brisbane")
                      .format("LLL")}{" "}
                    &nbsp;
                  </p>
                </div>
              );
            }
          })}

          <div
            className={
              this.state.uploadingChatFile ? "w-100 text-center" : "d-none"
            }
          >
            <CircularProgress disableShrink className="primary-loader m-auto" />
          </div>

          <div className={this.state.typingDoctorFlg ? "w-100" : "d-none"}>
            <strong className="float-left mr-1">
              {this.state.doctorData
                ? this.state.doctorData.firstName +
                " " +
                this.state.doctorData.lastName +
                " (Doctor)"
                : ""}
            </strong>
            <div className="ticontainer">
              <div className="tiblock">
                <div className="tidot"></div>
                <div className="tidot"></div>
                <div className="tidot"></div>
              </div>
            </div>
          </div>

          <div className={this.state.typingAdminFlg ? "float-right" : "d-none"}>
            <strong className="">
              {this.state.adminTypingData &&
                this.state.adminTypingData.firstName +
                " (" +
                (this.state.adminTypingData &&
                  this.state.adminTypingData.userType.includes("SUPPORT_STAFF")
                  ? "Support"
                  : "Admin") +
                ")"}
            </strong>
            <div className="ticontainer float-right ml-1">
              <div className="tiblock">
                <div className="tidot"></div>
                <div className="tidot"></div>
                <div className="tidot"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="send-message-container d-flex flex-row">
          <EmojiTextInput
            component="textarea" // Use textarea as the base component
            id="adminInputChat"
            name="adminInputChat"
            className="msg-input"
            rows="3"
            placeholder="Write your message..."
            value={this.state.msgInputValue}
            onChange={this.handleMsgInputChange}
            onKeyDown={this.handleKeyDown}
          />
          <div>
            <p className="mb-0 attachment" onClick={this.handleFileInput}>
              <i className="fa fa-paperclip"></i>
            </p>
            <div style={{ paddingLeft: "10px" }}>
              <EmojiInput onEmojiSelected={this.handleEmojiInput} />
            </div>
          </div>

          <p
            className="mb-0 send-btn"
            onClick={event => this.handleSendMsg(event)}
            disabled={this.state.disableSendMessageBtn}
          >
            <i className="fa fa-paper-plane"></i>
          </p>
        </div>

        {/* Hidden file input for custom desing */}
        <input
          type="file"
          id="file"
          accept="image/jpeg,image/gif,image/png,application/pdf"
          ref={this.inputUserChatFiles}
          style={{ display: "none" }}
          onChange={this.onChangeHandler}
        />

        <Model
          openModal={this.state.chatFileLargeModel}
          modalBodyContent="Selected file is too big!"
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          okayEvent={this.closeFileLargeModel}
          cancelEvent={this.closeFileLargeModel}
        />

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCallParams} />
      </div>
    );
  }
}

// export default Chat;

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(Chat);